import { atom } from "jotai";
import { CustomerJsonType } from "types/types";

export const TOOLTIP_PROPS = {
  placement: "top" as const,
  disableInteractive: true,
};

export const customerTilesPopupDataAtom = atom<{
  ckey: string;
  popupData: CustomerJsonType | Record<string, any> | null;
  adminUrls?: { url: string; name: string }[];
}>({ ckey: "", popupData: null });
